import { c as _c } from "react/compiler-runtime";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { type NotificationDisplayItem, isGroupedReactionsItem } from "@/types/feed.types";
import { memo, useMemo } from "react";
import NotificationDropReactedGroup from "./drop-reacted/NotificationDropReactedGroup";
import NotificationItem from "./NotificationItem";
interface NotificationItemsProps {
  readonly items: NotificationDisplayItem[];
  readonly activeDrop: ActiveDropState | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onMarkGroupAsRead?: ((ids: number[]) => Promise<void>) | undefined;
}
function NotificationItemsComponent(t0) {
  const $ = _c(15);
  const {
    items,
    activeDrop,
    onReply,
    onDropContentClick,
    onMarkGroupAsRead
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const keyedItems = t1;
  let t2;
  if ($[2] !== activeDrop || $[3] !== keyedItems || $[4] !== onDropContentClick || $[5] !== onMarkGroupAsRead || $[6] !== onReply) {
    let t3;
    if ($[8] !== activeDrop || $[9] !== onDropContentClick || $[10] !== onMarkGroupAsRead || $[11] !== onReply) {
      t3 = t4 => {
        const {
          item: item_0,
          key,
          domId
        } = t4;
        return <div key={key} id={domId}>{isGroupedReactionsItem(item_0) ? <div className="tw-flex"><div className="tw-relative lg:tw-hidden"><div className="tw-h-full tw-w-[1px] -tw-translate-x-8 tw-bg-iron-800" /></div><div className="tw-w-full"><NotificationDropReactedGroup group={item_0} activeDrop={activeDrop} onReply={onReply} onDropContentClick={onDropContentClick} onMarkAsRead={onMarkGroupAsRead ? ids => onMarkGroupAsRead(ids) : undefined} /></div></div> : <NotificationItem notification={item_0} activeDrop={activeDrop} onReply={onReply} onDropContentClick={onDropContentClick} />}</div>;
      };
      $[8] = activeDrop;
      $[9] = onDropContentClick;
      $[10] = onMarkGroupAsRead;
      $[11] = onReply;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = keyedItems.map(t3);
    $[2] = activeDrop;
    $[3] = keyedItems;
    $[4] = onDropContentClick;
    $[5] = onMarkGroupAsRead;
    $[6] = onReply;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[13] !== t2) {
    t3 = <div className="tw-flex tw-flex-col tw-space-y-3 tw-pb-3">{t2}</div>;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}
function _temp(item, index) {
  const keySuffix = isGroupedReactionsItem(item) ? `group-${item.drop.id}` : item.id ?? `fallback-${index}`;
  return {
    item,
    key: `notification-${keySuffix}`,
    domId: `feed-item-${keySuffix}`
  };
}
const NotificationItems = memo(NotificationItemsComponent, (prevProps, nextProps) => {
  return prevProps.items === nextProps.items && prevProps.activeDrop === nextProps.activeDrop && prevProps.onReply === nextProps.onReply && prevProps.onDropContentClick === nextProps.onDropContentClick && prevProps.onMarkGroupAsRead === nextProps.onMarkGroupAsRead;
});
NotificationItems.displayName = "NotificationItems";
export default NotificationItems;